export const API_URL = "/api";
export const API_BASE_URL = "";
export const API_AUTH_URL = `${API_URL}/auth`;
export const API_USER_URL = `${API_URL}/user`;

// Función para obtener la URL de una imagen
export const getImageUrl = (imagePath?: string) => {
  if (!imagePath) return '/images/user/owner.webp';
  if (imagePath.startsWith('http')) return imagePath;
  if (imagePath.startsWith('/')) return `${API_BASE_URL}${imagePath}`;
  return `${API_BASE_URL}/${imagePath}`;
};

// Exportar también la interfaz LoginCredentials
export interface LoginCredentials {
  email: string;
  password: string;
} 
